module.exports = __webpack_public_path__ + "img/6cf3a13.png";